"use client";

import { useEffect } from "react";

/**
 * 모바일에서 스와이프 다운으로 인한 페이지 새로고침 및 로그인 화면으로의 리다이렉트 방지
 */
export function PreventSwipeRefresh() {
  useEffect(() => {
    // 모바일에서 pull-to-refresh 방지
    let touchStartY = 0;
    let touchEndY = 0;

    const handleTouchStart = (e: TouchEvent) => {
      touchStartY = e.touches[0].clientY;
    };

    const handleTouchMove = (e: TouchEvent) => {
      touchEndY = e.touches[0].clientY;
      
      // 위에서 아래로 스와이프하는 경우 (pull-to-refresh) 방지
      if (touchStartY < touchEndY && window.scrollY === 0) {
        e.preventDefault();
      }
    };

    // beforeunload 이벤트로 페이지 새로고침 방지 (로그인 상태 유지)
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      // 로그인 상태가 있는 경우에만 방지
      const hasSession = document.cookie.includes("next-auth.session-token") || 
                        document.cookie.includes("__session") ||
                        localStorage.getItem("dev-dummy-user");
      
      if (hasSession) {
        // 기본 동작만 방지 (사용자에게 확인 메시지 표시하지 않음)
        e.preventDefault();
        e.returnValue = "";
      }
    };

    // 페이지 가시성 변경 시 인증 상태 확인
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        // 페이지가 다시 보일 때 인증 상태 확인
        // 로그인 상태가 있으면 리다이렉트하지 않음
        const hasSession = document.cookie.includes("next-auth.session-token") || 
                          document.cookie.includes("__session") ||
                          localStorage.getItem("dev-dummy-user");
        
        if (hasSession) {
          // 인증 상태가 있으면 아무것도 하지 않음
          return;
        }
      }
    };

    // 이벤트 리스너 등록
    document.addEventListener("touchstart", handleTouchStart, { passive: false });
    document.addEventListener("touchmove", handleTouchMove, { passive: false });
    document.addEventListener("visibilitychange", handleVisibilityChange);

    // CSS로 overscroll-behavior 강제 적용
    document.documentElement.style.overscrollBehavior = "none";
    document.body.style.overscrollBehavior = "none";

    return () => {
      document.removeEventListener("touchstart", handleTouchStart);
      document.removeEventListener("touchmove", handleTouchMove);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  return null;
}

